import { render, staticRenderFns } from "./undoOff.vue?vue&type=template&id=76a06be3&"
import script from "./undoOff.vue?vue&type=script&lang=ts&"
export * from "./undoOff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports